import siteConfig from "../config/siteConfig";

const APPAREL_SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
const HAT_SIZES = ["One Size"];

const createProduct = ({ sizes, features, ...product }) => ({
  brand: siteConfig.brandName,
  rating: 4.8,
  ...product,
  isNew: product.isNew ?? product.id <= 8,
  stock: product.stock ?? (product.id % 8 === 0 ? 0 : 12),
  image: product.images[0],
  size: sizes,
  material: product.attributes.material,
  Features: features,
});

const productData = [
  createProduct({
    id: 1,
    name: "Heavy Duty Baseball Tee - 2-Tone Natural & Kelly",
    category: "Heavy Duty Cotton",
    price: 145,
    reviews: 38,
    images: ["/img/products/product-01.jpg"],
    description: [
      "A substantial raglan tee cut with a relaxed athletic line and a dry, structured hand.",
      "Natural body panels and Kelly sleeves give the everyday silhouette a lively vintage-training contrast.",
    ],
    attributes: {
      material: "10 oz ringspun cotton jersey",
      construction: "Flatlock raglan seams with bound collar",
      fit: "Relaxed athletic fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["baseball tee", "heavyweight", "raglan", "cotton jersey"],
    colors: ["Natural / Kelly", "Natural / Forest"],
    sizes: APPAREL_SIZES,
    features: [
      "Dense heavyweight jersey",
      "Contrast three-quarter raglan sleeves",
      "Reinforced rib neckline",
      "Pre-shrunk for a consistent fit",
    ],
  }),
  createProduct({
    id: 2,
    name: "Heavy Duty Baseball Tee - 2-Tone Natural & Red",
    category: "Heavy Duty Cotton",
    price: 145,
    reviews: 31,
    images: ["/img/products/product-02.jpg"],
    description: [
      "A rugged baseball tee built from weighty cotton jersey with a softly broken-in surface.",
      "Brick-red sleeves frame the natural body for an old gymnasium palette that layers easily.",
    ],
    attributes: {
      material: "10 oz ringspun cotton jersey",
      construction: "Flatlock raglan seams with coverstitched hem",
      fit: "Relaxed athletic fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["baseball tee", "heritage sport", "heavyweight", "raglan"],
    colors: ["Natural / Red", "Natural / Oxblood"],
    sizes: APPAREL_SIZES,
    features: [
      "Three-quarter contrast sleeves",
      "Wide vintage-inspired collar rib",
      "Durable flatlock construction",
      "Garment washed for softness",
    ],
  }),
  createProduct({
    id: 3,
    name: "Heavy Duty Baseball Tee - White",
    category: "Heavy Duty Cotton",
    price: 145,
    reviews: 27,
    images: ["/img/products/product-03.jpg"],
    description: [
      "A clean monochrome interpretation of the classic baseball shirt in dense white jersey.",
      "The weight holds its shape while the raglan pattern keeps movement easy through the shoulders.",
    ],
    attributes: {
      material: "10 oz combed cotton jersey",
      construction: "Raglan shoulder with flatlocked seams",
      fit: "Easy straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["baseball tee", "white tee", "heavyweight", "essential"],
    colors: ["White", "Ecru"],
    sizes: APPAREL_SIZES,
    features: [
      "Opaque heavyweight jersey",
      "Three-quarter sleeves",
      "Reinforced crew neck",
      "Tubular-style body finish",
    ],
  }),
  createProduct({
    id: 4,
    name: "Baseball Hat - Olive Drab Corduroy",
    category: "Accessories",
    price: 75,
    reviews: 19,
    images: ["/img/products/product-04.jpg"],
    description: [
      "A low-profile six-panel cap in tactile olive corduroy with a workwear-minded finish.",
      "The unstructured crown softens with wear while the brim retains a crisp, useful shape.",
    ],
    attributes: {
      material: "Eight-wale cotton corduroy",
      construction: "Six-panel crown with stitched eyelets",
      fit: "Adjustable low profile",
      weight: "Midweight",
      origin: "Please refer to the garment label",
    },
    tags: ["baseball hat", "corduroy", "olive", "accessory"],
    colors: ["Olive Drab", "Moss"],
    sizes: HAT_SIZES,
    features: [
      "Soft unstructured crown",
      "Leather back adjuster",
      "Cotton sweatband",
      "Tonal embroidered eyelets",
    ],
  }),
  createProduct({
    id: 5,
    name: "Waxed Baseball Hat - Faded Blue Dry Waxed Rip Stop",
    category: "Accessories",
    price: 75,
    reviews: 24,
    images: ["/img/products/product-05.jpg"],
    description: [
      "A weather-minded cap made from dry-waxed ripstop in a sun-faded work blue.",
      "Its matte finish resists light showers without the tacky hand of traditional waxed cloth.",
    ],
    attributes: {
      material: "Dry-waxed cotton ripstop",
      construction: "Six-panel crown with taped interior seams",
      fit: "Adjustable low profile",
      weight: "Lightweight",
      origin: "Please refer to the garment label",
    },
    tags: ["waxed hat", "ripstop", "weather resistant", "faded blue"],
    colors: ["Faded Blue", "Storm Blue"],
    sizes: HAT_SIZES,
    features: [
      "Dry wax weather finish",
      "Reinforced ripstop weave",
      "Antique brass adjuster",
      "Moisture-absorbing inner band",
    ],
  }),
  createProduct({
    id: 6,
    name: "Waxed Baseball Hat - Sage Dry Waxed Cotton",
    category: "Accessories",
    price: 75,
    reviews: 22,
    images: ["/img/products/product-06.jpg"],
    description: [
      "A compact everyday cap cut from sage cotton with a quiet dry-wax finish.",
      "The cloth develops subtle creases and tonal character as it travels and wears in.",
    ],
    attributes: {
      material: "Dry-waxed cotton canvas",
      construction: "Six-panel crown with bound interior seams",
      fit: "Adjustable low profile",
      weight: "Midweight",
      origin: "Please refer to the garment label",
    },
    tags: ["waxed hat", "canvas", "sage", "utility"],
    colors: ["Sage", "Lichen"],
    sizes: HAT_SIZES,
    features: [
      "Water-shedding dry wax finish",
      "Moldable stitched brim",
      "Brass slide adjuster",
      "Tonal cotton lining tape",
    ],
  }),
  createProduct({
    id: 7,
    name: "Waxed Baseball Hat - 2-Tone Sage & Spruce Dry Waxed Cotton",
    category: "Accessories",
    price: 75,
    reviews: 16,
    images: ["/img/products/product-07.jpg"],
    description: [
      "A two-tone waxed cap pairing a muted sage crown with a deep spruce brim.",
      "Durable cotton canvas and restrained contrast give it the feel of a well-kept field uniform.",
    ],
    attributes: {
      material: "Dry-waxed cotton canvas",
      construction: "Contrast six-panel crown with reinforced brim",
      fit: "Adjustable low profile",
      weight: "Midweight",
      origin: "Please refer to the garment label",
    },
    tags: ["waxed hat", "two tone", "sage", "spruce"],
    colors: ["Sage / Spruce", "Olive / Pine"],
    sizes: HAT_SIZES,
    features: [
      "Two-tone field palette",
      "Matte weather-resistant coating",
      "Adjustable leather strap",
      "Breathable stitched eyelets",
    ],
  }),
  createProduct({
    id: 8,
    name: "2-Tone Baseball Hat - Faded Tan Canvas & Fawn Corduroy",
    category: "Accessories",
    price: 75,
    reviews: 18,
    images: ["/img/products/product-08.jpg"],
    description: [
      "A mixed-texture cap combining faded tan canvas with a warm fawn corduroy brim.",
      "The neutral pairing recalls vintage shop uniforms and gains depth as both fabrics age.",
    ],
    attributes: {
      material: "Cotton duck canvas and eight-wale corduroy",
      construction: "Six-panel mixed-fabric crown",
      fit: "Adjustable low profile",
      weight: "Midweight",
      origin: "Please refer to the garment label",
    },
    tags: ["baseball hat", "two tone", "canvas", "corduroy"],
    colors: ["Faded Tan / Fawn", "Khaki / Tobacco"],
    sizes: HAT_SIZES,
    features: [
      "Mixed canvas and corduroy build",
      "Softened garment wash",
      "Adjustable brass closure",
      "Reinforced curved brim",
    ],
  }),
  createProduct({
    id: 9,
    name: "Heavy Duty Tee - Single Pocket - Clover",
    category: "Heavy Duty Cotton",
    price: 72,
    reviews: 44,
    images: ["/img/products/product-09.jpg"],
    description: [
      "A dense pocket tee in saturated clover green, balanced by a straight vintage work-shirt fit.",
      "The jersey begins structured and eases naturally at stress points without losing its shape.",
    ],
    attributes: {
      material: "9 oz ringspun cotton jersey",
      construction: "Single-needle chest pocket with taped shoulder seams",
      fit: "Classic straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["pocket tee", "heavyweight", "clover", "workwear"],
    colors: ["Clover", "Pine"],
    sizes: APPAREL_SIZES,
    features: [
      "Stable chest pocket",
      "High-density collar rib",
      "Shoulder-to-shoulder taping",
      "Garment washed finish",
    ],
  }),
  createProduct({
    id: 10,
    name: "Heavy Duty Tee - Single Pocket - Faded Blue",
    category: "Heavy Duty Cotton",
    price: 72,
    reviews: 41,
    images: ["/img/products/product-10.jpg"],
    description: [
      "A substantial pocket tee in a softly weathered blue with the heft of classic everyday basics.",
      "Its roomy torso and firm neck rib are designed to settle into a personal fit over time.",
    ],
    attributes: {
      material: "9 oz ringspun cotton jersey",
      construction: "Bound neck and single chest pocket",
      fit: "Classic straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["pocket tee", "faded blue", "heavyweight", "everyday"],
    colors: ["Faded Blue", "Washed Navy"],
    sizes: APPAREL_SIZES,
    features: [
      "Color-washed surface",
      "Reinforced pocket corners",
      "Set-in sleeves",
      "Coverstitched bottom hem",
    ],
  }),
  createProduct({
    id: 11,
    name: "Heavy Duty Tee - Single Pocket - Palomino",
    category: "Heavy Duty Cotton",
    price: 72,
    reviews: 35,
    images: ["/img/products/product-11.jpg"],
    description: [
      "A warm palomino pocket tee with a dry cotton hand and sturdy drape.",
      "The earthy shade works as a tonal base beneath denim, waxed canvas, and wool outerwear.",
    ],
    attributes: {
      material: "9 oz ringspun cotton jersey",
      construction: "Set-in sleeve with reinforced chest pocket",
      fit: "Classic straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["pocket tee", "palomino", "heavyweight", "layering"],
    colors: ["Palomino", "Golden Brown"],
    sizes: APPAREL_SIZES,
    features: [
      "Garment-dyed color depth",
      "Durable neck binding",
      "Clean single chest pocket",
      "Pre-laundered cotton jersey",
    ],
  }),
  createProduct({
    id: 12,
    name: "Heavy Duty Tee - Single Pocket - Putty",
    category: "Heavy Duty Cotton",
    price: 72,
    reviews: 33,
    images: ["/img/products/product-12.jpg"],
    description: [
      "A neutral putty pocket tee with enough weight to wear alone and enough room to layer.",
      "Subtle slub variation keeps the restrained color from feeling flat or clinical.",
    ],
    attributes: {
      material: "9 oz slub cotton jersey",
      construction: "Set-in sleeves with taped upper seams",
      fit: "Classic straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["pocket tee", "neutral", "heavyweight", "slub cotton"],
    colors: ["Putty", "Warm Stone"],
    sizes: APPAREL_SIZES,
    features: [
      "Subtle slub texture",
      "Reinforced pocket opening",
      "Firm rib-knit collar",
      "Double-needle hems",
    ],
  }),
  createProduct({
    id: 13,
    name: "Heavy Duty Tee - Single Pocket - Roma",
    category: "Heavy Duty Cotton",
    price: 72,
    reviews: 29,
    images: ["/img/products/product-13.jpg"],
    description: [
      "A work-ready pocket tee in deep Roma red, built with a compact jersey that resists twisting.",
      "The rich shade adds color while retaining the honest simplicity of an everyday uniform piece.",
    ],
    attributes: {
      material: "9 oz compact cotton jersey",
      construction: "Side-seamed body with bartacked chest pocket",
      fit: "Classic straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["pocket tee", "roma red", "heavyweight", "workwear"],
    colors: ["Roma", "Brick Red"],
    sizes: APPAREL_SIZES,
    features: [
      "Compact low-twist jersey",
      "Bartacked pocket corners",
      "Set-in short sleeves",
      "Colorfast garment dye",
    ],
  }),
  createProduct({
    id: 14,
    name: "Lounge Shirt - Lawn Chair Plaid",
    category: "Shirts",
    price: 260,
    reviews: 17,
    images: ["/img/products/product-14.jpg"],
    description: [
      "A relaxed open-collar shirt in a breezy plaid inspired by sun-faded outdoor textiles.",
      "Room through the chest and a square hem create an easy overshirt silhouette for warm days.",
    ],
    attributes: {
      material: "Cotton-linen woven plaid",
      construction: "Camp collar with clean-finished interior seams",
      fit: "Relaxed boxy fit",
      weight: "Lightweight",
      origin: "Please refer to the garment label",
    },
    tags: ["lounge shirt", "plaid", "camp collar", "summer"],
    colors: ["Lawn Chair Plaid", "Sunwashed Plaid"],
    sizes: APPAREL_SIZES,
    features: [
      "Open camp collar",
      "Matched chest pocket pattern",
      "Natural corozo buttons",
      "Straight vented hem",
    ],
  }),
  createProduct({
    id: 15,
    name: "Lounge Shirt - Natural Sashi-Ori",
    category: "Shirts",
    price: 260,
    reviews: 21,
    images: ["/img/products/product-15.jpg"],
    description: [
      "A textured lounge shirt woven in natural cotton with a dimensional sashiko-like surface.",
      "The open collar and generous cut let the fabric breathe while highlighting its quiet structure.",
    ],
    attributes: {
      material: "Textured cotton sashi-ori weave",
      construction: "Camp collar with French-seamed yoke",
      fit: "Relaxed boxy fit",
      weight: "Midweight",
      origin: "Please refer to the garment label",
    },
    tags: ["lounge shirt", "sashi-ori", "textured cotton", "natural"],
    colors: ["Natural", "Oatmeal"],
    sizes: APPAREL_SIZES,
    features: [
      "Dimensional woven texture",
      "Open camp collar",
      "Corozo button front",
      "Side-seam vents",
    ],
  }),
  createProduct({
    id: 16,
    name: "Heavy Duty Tee - Support Your Local / Faded Blue",
    category: "Heavy Duty Cotton",
    price: 75,
    reviews: 52,
    images: ["/img/products/product-16.jpg"],
    description: [
      "A faded-blue heavyweight tee carrying a small community-minded shop graphic.",
      "The print is intentionally restrained so the substantial jersey and easy work fit stay central.",
    ],
    attributes: {
      material: "9 oz ringspun cotton jersey",
      construction: "Set-in sleeve with water-based screen print",
      fit: "Classic straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["graphic tee", "faded blue", "local makers", "heavyweight"],
    colors: ["Faded Blue", "Dusty Marine"],
    sizes: APPAREL_SIZES,
    features: [
      "Soft-hand original graphic",
      "Reinforced collar rib",
      "Garment-washed finish",
      "Double-needle sleeve hems",
    ],
  }),
  createProduct({
    id: 17,
    name: "Heavy Duty Tee - Track Tee / Clover",
    category: "Heavy Duty Cotton",
    price: 75,
    reviews: 46,
    images: ["/img/products/product-17.jpg"],
    description: [
      "A clover-green heavyweight tee with a compact track-club graphic and sturdy vintage proportions.",
      "It feels substantial from the first wear and softens gradually without collapsing at the collar.",
    ],
    attributes: {
      material: "9 oz ringspun cotton jersey",
      construction: "Set-in sleeve with water-based chest print",
      fit: "Classic straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["graphic tee", "track tee", "clover", "heavyweight"],
    colors: ["Clover", "Deep Green"],
    sizes: APPAREL_SIZES,
    features: [
      "Original athletics-inspired artwork",
      "High-recovery collar",
      "Dense opaque jersey",
      "Pre-shrunk garment wash",
    ],
  }),
  createProduct({
    id: 18,
    name: "Heavy Duty Tee - Vintage Label / Palomino",
    category: "Heavy Duty Cotton",
    price: 75,
    reviews: 39,
    images: ["/img/products/product-18.jpg"],
    description: [
      "A palomino heavyweight tee finished with a modest archival-style label graphic.",
      "Warm pigment color and a slightly dry hand evoke a favorite shop shirt from another era.",
    ],
    attributes: {
      material: "9 oz pigment-dyed cotton jersey",
      construction: "Set-in sleeve with discharge-style print",
      fit: "Classic straight fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["graphic tee", "vintage label", "palomino", "heritage"],
    colors: ["Palomino", "Tobacco Gold"],
    sizes: APPAREL_SIZES,
    features: [
      "Low-profile vintage graphic",
      "Pigment-dyed character",
      "Taped shoulder seams",
      "Sturdy rib-knit collar",
    ],
  }),
  createProduct({
    id: 19,
    name: "Spring Slouchy Cardigan - Forster Red",
    category: "Sweaters",
    price: 360,
    reviews: 25,
    images: ["/img/products/product-19.jpg"],
    description: [
      "A relaxed spring cardigan in vivid Forster red, knit with a breathable body and deliberate slouch.",
      "Dropped shoulders and deep rib trims make it an easy outer layer without losing its tailored rhythm.",
    ],
    attributes: {
      material: "Cotton-wool marled yarn",
      construction: "Fully fashioned knit with linked seams",
      fit: "Relaxed slouchy fit",
      weight: "Midweight",
      origin: "Please refer to the garment label",
    },
    tags: ["cardigan", "knitwear", "forster red", "spring layer", "women"],
    colors: ["Forster Red", "Rust Red"],
    sizes: APPAREL_SIZES,
    features: [
      "Breathable marled knit",
      "Deep patch pockets",
      "Chunky corozo buttons",
      "Shape-retaining rib trims",
    ],
  }),
  createProduct({
    id: 20,
    name: "Spring Slouchy Cardigan - Old Gold",
    category: "Sweaters",
    price: 375,
    reviews: 23,
    images: ["/img/products/product-20.jpg"],
    description: [
      "A loose-gauge cardigan in old gold with the warm presence of vintage collegiate knitwear.",
      "Its generous shape works over a tee or overshirt while dense ribbing keeps the edges controlled.",
    ],
    attributes: {
      material: "Cotton-wool marled yarn",
      construction: "Fully fashioned knit with linked seams",
      fit: "Relaxed slouchy fit",
      weight: "Midweight",
      origin: "Please refer to the garment label",
    },
    tags: ["cardigan", "knitwear", "old gold", "collegiate", "women"],
    colors: ["Old Gold", "Ochre"],
    sizes: APPAREL_SIZES,
    features: [
      "Textured marled yarn",
      "Wide front placket",
      "Two patch pockets",
      "Reinforced shoulder seams",
    ],
  }),
  createProduct({
    id: 21,
    name: "Pilot Jacket - Sage Dry Waxed Cotton",
    category: "Jackets",
    price: 575,
    reviews: 28,
    images: ["/img/products/product-21.jpg"],
    description: [
      "A short utility jacket in matte sage dry-waxed cotton with a clean pilot-inspired stance.",
      "Purposeful pockets, a two-way front, and a compact collar balance weather protection with daily mobility.",
    ],
    attributes: {
      material: "12 oz dry-waxed cotton canvas",
      construction: "Bound internal seams with two-way metal zip",
      fit: "Regular cropped fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["pilot jacket", "waxed cotton", "sage", "outerwear"],
    colors: ["Sage", "Field Olive"],
    sizes: APPAREL_SIZES,
    features: [
      "Matte water-resistant finish",
      "Two-way brass zipper",
      "Angled hand pockets",
      "Adjustable snap cuffs",
    ],
  }),
  createProduct({
    id: 22,
    name: "Woven Chore Coat - Sage Dry Waxed Cotton",
    category: "Jackets",
    price: 425,
    reviews: 32,
    images: ["/img/products/product-22.jpg"],
    description: [
      "A straightforward chore coat rendered in sage dry-waxed canvas for practical all-season coverage.",
      "Three generous exterior pockets and a lightly structured body keep tools and essentials close at hand.",
    ],
    attributes: {
      material: "11 oz dry-waxed cotton duck",
      construction: "Triple-needle stress seams with bar-tacked pockets",
      fit: "Straight layering fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["chore coat", "waxed cotton", "workwear", "sage"],
    colors: ["Sage", "Dusty Olive"],
    sizes: APPAREL_SIZES,
    features: [
      "Three utility patch pockets",
      "Dry-wax weather resistance",
      "Reinforced elbow panels",
      "Tack-button front closure",
    ],
  }),
  createProduct({
    id: 23,
    name: "Utility Overshirt - Camel",
    category: "Shirts",
    price: 495,
    reviews: 26,
    images: ["/img/products/product-23.jpg"],
    description: [
      "A warm camel overshirt with the presence of a light jacket and the ease of a familiar button-up.",
      "Its broad chest pockets and softly structured collar create a refined layer over heavyweight tees.",
    ],
    attributes: {
      material: "Wool-cotton basket weave",
      construction: "Flat-felled seams with reinforced pocketing",
      fit: "Relaxed overshirt fit",
      weight: "Midweight",
      origin: "Please refer to the garment label",
    },
    tags: ["overshirt", "camel", "wool blend", "layering"],
    colors: ["Camel", "Warm Sand"],
    sizes: APPAREL_SIZES,
    features: [
      "Dual flap chest pockets",
      "Soft brushed interior",
      "Corozo button closure",
      "Shaped shirt-tail hem",
    ],
  }),
  createProduct({
    id: 24,
    name: "Utility Overshirt - Rust Corduroy",
    category: "Shirts",
    price: 495,
    reviews: 30,
    images: ["/img/products/product-24.jpg"],
    description: [
      "A jacket-weight overshirt in deep rust corduroy with a rich, directional surface.",
      "The roomy cut accommodates knitwear while balanced pockets and a clean placket keep the profile composed.",
    ],
    attributes: {
      material: "Heavy eight-wale cotton corduroy",
      construction: "Flat-felled seams with lined collar stand",
      fit: "Relaxed overshirt fit",
      weight: "Heavyweight",
      origin: "Please refer to the garment label",
    },
    tags: ["overshirt", "corduroy", "rust", "workwear"],
    colors: ["Rust", "Red Oak"],
    sizes: APPAREL_SIZES,
    features: [
      "Jacket-weight corduroy",
      "Dual chest pockets",
      "Durable corozo buttons",
      "Adjustable button cuffs",
    ],
  }),
];

export default productData;
